//basic
import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//style
import './Article.scss';

//custom components
import CustomInput from '../../../components/basic/input';

//material-ui
import { CircularProgress, Paper, Grid, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';

//other libraries
import Icon from '@mdi/react'
import { mdiClose } from '@mdi/js'
import ReactQuill, { Quill } from 'react-quill';

const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiInput: {
            underline: {
                "&::after": {
                    borderBottomColor: "#777777",
                    borderBottom: "2px solid #777777 !important"
                }
            },
            disabled: {
                "&::before" : {
                    borderBottom: "1px solid #777777 !important"
                }
            }
        },
        MuiFormControl: {
            root: {
                width: "100%",
                marginBottom: "10px",
            },
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class Article extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            editorHtml: '',
            title: "",
            alias: "",
            menu_position: "",
            production: false,
        }
    }

    componentDidMount() {
        this.props.internal.setRoute(this.props.history, this.props.location.pathname);
        this.props.internal.setHeaderTitle(this.props.translate.i18n.MODULES.MENU.MENU_ARTICLE);
        this.loadArticle()
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    loadArticle = async() => {
        let idArticle = this.props.match.params.id
        let load_data = await api({
            method:'get',
            url: `lists/frontend-menu/${idArticle}`,
            authorization: this.props.internal.user.access_token,
        })
        if(load_data.success === true) {
            this.setState({
                loading: false,
                editorHtml: load_data.data.data.content,
                title: load_data.data.data.name,
                alias: load_data.data.data.alias,
                menu_position: load_data.data.data.menu_position,
                production: load_data.data.data.production,
            })
        }
    }


    handleChangeHTML = (html) => {
        this.setState({ editorHtml: html });
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.updateArticle()
        }, 1000)
        
    }

    modules = {
        toolbar: [
            ['bold', 'italic', 'underline'], // 'strike', 'blockquote'
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{'list': 'ordered'}, {'list': 'bullet'}], // {'indent': '-1'}, {'indent': '+1'}
            [{ "size": [ 'small', false, 'large', 'huge' ]}],
            [{"color": []}, {background: []}],
            [{"align": []}],
            ['link'],
            ['image'],
            ['video'],
            
        ],
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        }
    }
      /*
       * Quill editor formats
       * See https://quilljs.com/docs/formats/
       */
    formats = [
        'bold', 'italic', 'underline',
        'header',
        'list', 'bullet',
        'size',
        'color',
        'background',
        'align',
        'link',
        'image',
        'video'
    ]

    handleChange = (item, val) => {
        if(item === "title") {
            this.setState({title: this.title.state.value})
        }
        else{
            this.setState({[item]: val.target.value})
        }
        
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.updateArticle()
        }, 1000)
    }

    updateArticle = async() => {
        let idArticle = this.props.match.params.id
        let update_data = await api({
            method:'patch',
            url: `lists/frontend-menu/${idArticle}`,
            authorization: this.props.internal.user.access_token,
            params: {
                name: this.state.title,
                menu_position: this.state.menu_position,
                content: this.state.editorHtml,
                production: this.state.production,
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    goBack = () => {
        this.props.internal.pushRoute(`/${Number(this.props.match.params.idShop)}/menu?menu_position=${this.state.menu_position}`)
    }

    render () {
        return (
            this.state.loading ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'article'}>
                    <div className={'flex header'}>
                        <h1 className={'title'}>{this.props.translate.i18n.MODULES.MENU.EDIT_ARTICLE}</h1>
                        <div className={'back-btn'} onClick={this.goBack}>
                            <Icon path={mdiClose} size={1}/>
                        </div>
                    </div>
                    <MuiThemeProvider theme={materialTheme}>
                        <Grid container spacing={16} >
                            <Grid item xs={12} sm={4}>
                                <Paper className={'item'} >
                                    <CustomInput
                                        ref={ref => (this.title = ref)}
                                        text={this.props.translate.i18n.MODULES.MENU.TITLE}
                                        value={this.state.title}
                                        id={"title"}
                                        className={"w-100"}
                                        required
                                        change={(val) => this.handleChange('title', val)}
                                    />
                                    <CustomInput
                                        ref={ref => (this.alias = ref)}
                                        text={this.props.translate.i18n.MODULES.MENU.ALIAS}
                                        value={this.state.alias}
                                        id={"alias"}
                                        className={"w-100"}
                                        disabled
                                    />
                                    <FormControl className="select-type-position">
                                        <InputLabel
                                            htmlFor="menu-position"
                                            className={"label-select-type"}
                                            // shrink={true}
                                        >
                                            {this.props.translate.i18n.MODULES.MENU.MENU_POSITION_LABEL}
                                        </InputLabel>
                                        <Select
                                            classes={{
                                                root: "select-menu-position-root",
                                            }}
                                            value={this.state.menu_position}
                                            // onChange={this.handleChangePosition}
                                            onChange={(val) => this.handleChange('menu_position', val)}
                                            inputProps={{
                                                name: "menu_position",
                                                id: "menu-position",
                                            }}
                                            // displayEmpty
                                        >
                                            <MenuItem value="top">{this.props.translate.i18n.MODULES.MENU.MENU_POSITION.MAIN}</MenuItem>
                                            <MenuItem value="bot">{this.props.translate.i18n.MODULES.MENU.MENU_POSITION.BOTTOM}</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl className="select-type-position">
                                        <InputLabel
                                            htmlFor="production"
                                            className={"label-select-type"}
                                            // shrink={true}
                                        >
                                            {this.props.translate.i18n.MODULES.MENU.PRODUCTION}
                                        </InputLabel>
                                        <Select
                                            classes={{
                                                root: "select-menu-position-root",
                                            }}
                                            value={this.state.production}
                                            // onChange={this.handleChangePosition}
                                            onChange={(val) => this.handleChange('production', val)}
                                            inputProps={{
                                                name: "menu_position",
                                                id: "production",
                                            }}
                                            // displayEmpty
                                        >
                                            <MenuItem value={true}>{this.props.translate.i18n.MODULES.MENU.PRODUCTION_STATUS.YES}</MenuItem>
                                            <MenuItem value={false}>{this.props.translate.i18n.MODULES.MENU.PRODUCTION_STATUS.NO}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={8} >
                                <Paper className={'item'}>
                                    <ReactQuill
                                        className={''}
                                        theme="snow"
                                        onChange={this.handleChangeHTML}
                                        value={this.state.editorHtml}
                                        modules={this.modules}
                                        formats={this.formats}
                                        bounds={'.app'}
                                        placeholder={''}
                                    />
                                </Paper>
                            </Grid>
                        </Grid>
                    </MuiThemeProvider>
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/menu/article/Article.jsx